// Central place for site-wide SEO constants so meta tags, JSON-LD and the
// sitemap generator all agree on the same values.

export const SITE_URL = "https://synergonenergy.bg";
export const SITE_NAME = "Synergon Energy";
export const SITE_LEGAL_NAME = "Синергон Енерджи ООД";
export const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

export const CONTACT = {
  phone: "+359 700 800 80",
  phoneDisplay: "0700 800 80",
  email: "office@synergonenergy.bg",
  street: "ул. „Бачо Киро“ № 23",
  streetEn: "23 Bacho Kiro Street",
  city: "София",
  cityEn: "Sofia",
  country: "BG",
  openingHours: "Mo-Fr 08:30-17:00",
};

export const DEFAULT_DESCRIPTION = {
  bg: "Synergon Energy е българският доставчик на ток, който Ви изготвя персонална оферта, грижи се вместо Вас за прехвърлянето и Ви спестява пари.",
  en: "Synergon Energy is the Bulgarian electricity supplier that prepares a personal offer for you, handles the switch on your behalf and saves you money.",
};

export const DEFAULT_TITLE = {
  bg: "Synergon Energy — доставчик на електроенергия за бизнеса и дома",
  en: "Synergon Energy — electricity supplier for business and home",
};

// Routes that are transactional form steps: no unique indexable content and
// several of them render the same component, so keep them out of the index.
export const NOINDEX_ROUTES = ["/offers-users", "/offers-manufacturers", "/offer-manufacturer", "/offer-user"];
